import * as actions from "../actions/actions";
import { connect } from "react-redux";

import React from "react";
import { CustomPicker } from "react-color";
import PointerCircle from "./nounproject-color-picker-pointer";
import PointerHue from "./nounproject-color-picker-hue";

var tinycolor = require("tinycolor2");

var { Hue } = require("react-color/lib/components/common");
var { Saturation } = require("react-color/lib/components/common");

const hexOrTransparent = props => {
    let { hex } = props;
    if (props.rgb && props.rgb.a == 0 && hex == "#000000") {
        hex = "transparent";
    }
    return hex;
};

class ColorPicker extends React.Component {
    constructor(props) {
        super(props);

        let hex = hexOrTransparent(props);
        this.state = {
            color: {
                hex,
                rgb: props.rgb,
                hsl: props.hsl
            }
        };
    }

    validateHexValue(e) {
        let newHex;

        newHex = e.target.value;

        if (/(^[0-9A-F]{6}$)/i.test(newHex)) {
            newHex = `#${newHex}`;

            let newCustomColor = {
                customColors: Object.assign({}, this.props.colorPalette),
                selectedColor: { hex: newHex }
            };
            this.props.setColor(newCustomColor);
        }
    }

    validateHexString(e) {
        let newHex;

        newHex = e.target.value;

        if (/(^[0-9A-F]{6}$)|(^[0-9A-F]{3}$)/i.test(newHex)) {
            newHex = `#${newHex}`;
            let newCustomColor = {
                customColors: Object.assign({}, this.props.colorPalette),
                selectedColor: { hex: newHex }
            };
            this.props.setColor(newCustomColor);
        }
    }

    updateHexColor(e) {
        let newColor = Object.assign({}, this.state.color);

        newColor.hex = `#${e.target.value}`;

        if (newColor.hex.replace("#", "").length < 7) {
            this.setState({
                color: newColor
            });
        }
    }

    updateAColor(keyName, value) {
        let newColor = Object.assign({}, this.state.color),
            newHex,
            tColor;

        switch (keyName) {
            case "r":
                if (parseInt(value) > 255) return;
                if (!isNaN(parseInt(value))) {
                    newColor.rgb.r = parseInt(value);
                    tColor = tinycolor({
                        r: newColor.rgb.r,
                        g: newColor.rgb.g,
                        b: newColor.rgb.b
                    });
                    newHex = `#${tColor.toHex()}`;
                    newColor.hex = newHex;
                    newColor.hsl = tColor.toHsl();
                }
                break;
            case "g":
                if (parseInt(value) > 255) return;
                if (!isNaN(parseInt(value))) {
                    newColor.rgb.g = parseInt(value);
                    tColor = tinycolor({
                        r: newColor.rgb.r,
                        g: newColor.rgb.g,
                        b: newColor.rgb.b
                    });
                    newHex = `#${tColor.toHex()}`;
                    newColor.hex = newHex;
                    newColor.hsl = tColor.toHsl();
                }
                break;
            case "b":
                if (parseInt(value) > 255) return;
                if (!isNaN(parseInt(value))) {
                    newColor.rgb.b = parseInt(value);
                    tColor = tinycolor({
                        r: newColor.rgb.r,
                        g: newColor.rgb.g,
                        b: newColor.rgb.b
                    });
                    newHex = `#${tColor.toHex()}`;
                    newColor.hex = newHex;
                    newColor.hsl = tColor.toHsl();
                }
                break;
            case "h":
                if (parseInt(value) > 359) return;
                if (!isNaN(parseInt(value))) {
                    newColor.hsl.h = parseInt(value);
                } else {
                    newColor.hsl.h = 0;
                }
                tColor = tinycolor({
                    h: newColor.hsl.h,
                    s: newColor.hsl.s,
                    l: newColor.hsl.l
                });
                newHex = `#${tColor.toHex()}`;
                newColor.hex = newHex;
                newColor.rgb = tColor.toRgb();
                break;
            case "s":
                if (parseInt(value) > 100) return;
                if (!isNaN(parseInt(value))) {
                    newColor.hsl.s = parseFloat(`${parseInt(value)}%`) / 100.0;
                } else {
                    newColor.hsl.s = 0;
                }
                tColor = tinycolor({
                    h: newColor.hsl.h,
                    s: newColor.hsl.s,
                    l: newColor.hsl.l
                });
                newHex = `#${tColor.toHex()}`;
                newColor.hex = newHex;
                newColor.rgb = tColor.toRgb();
                break;
            case "l":
                if (parseInt(value) > 100) return;
                if (!isNaN(parseInt(value))) {
                    newColor.hsl.l = parseFloat(`${value}%`) / 100.0;
                } else {
                    newColor.hsl.l = 0;
                }
                tColor = tinycolor({
                    h: newColor.hsl.h,
                    s: newColor.hsl.s,
                    l: newColor.hsl.l
                });
                newHex = `#${tColor.toHex()}`;
                newColor.hex = newHex;
                newColor.rgb = tColor.toRgb();
                break;
        }

        if (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(newHex)) {
            let newCustomColor = {
                customColors: Object.assign([], this.props.colorPalette),
                selectedColor: { hex: newHex }
            };
            this.props.setColor(newCustomColor);
        }

        this.setState({
            color: newColor
        });
    }

    componentWillReceiveProps(nextProps, nextState) {
        let newColor = Object.assign({}, this.state.color),
            newColorPalette = Object.assign({}, nextProps.colorPalette),
            newSelectedColor = Object.assign({}, nextProps.selectedColor),
            newCustomColor;

        let newHex = hexOrTransparent(nextProps);
        if (newSelectedColor.hex !== newHex) {
            newColor.hex = newHex;
            newColor.rgb = nextProps.rgb;
            newColor.hsl = nextProps.hsl;

            this.setState({
                color: newColor
            });

            newSelectedColor = { hex: newHex };

            newCustomColor = {
                customColors: newColorPalette,
                selectedColor: newSelectedColor
            };
            if (newSelectedColor.hex !== nextProps.color.hex) {
                this.props.setColor(newCustomColor);
            }
        }
    }

    handleInputChange(e) {
        this.updateAColor(e.target.name, e.target.value);
    }

    render() {
        let saturationStyles = {
            width: "180px",
            height: "180px",
            position: "relative",
            ...this.props.saturationStyles
        };
        let hueStyles = {
            width: "24px",
            height: "180px",
            position: "relative",
            ...this.props.hueStyles
        };
        return (
            <div id="custom-color-picker" className="display-flex">
                <div className="display-flex">
                    <div id="hue" style={hueStyles}>
                        <Hue
                            {...this.props}
                            pointer={PointerHue}
                            direction={"vertical"}
                        />
                    </div>
                    <div id="Saturation" style={saturationStyles}>
                        <Saturation {...this.props} pointer={PointerCircle} />
                    </div>
                </div>
                <div className="custom-color-inputs">
                    <div className="color-box-group">
                        <div>
                            <label>#</label>
                            <input
                                name="hex"
                                value={this.state.color.hex.replace("#", "")}
                                placeholder="Hex Color"
                                onKeyUp={this.validateHexValue.bind(this)}
                                onBlur={this.validateHexString.bind(this)}
                                onChange={this.updateHexColor.bind(this)}
                            />
                        </div>
                    </div>
                    <div className="color-box-group">
                        <div>
                            <label>R</label>
                            <input
                                name="r"
                                value={this.state.color.rgb.r}
                                placeholder="Red"
                                onChange={this.handleInputChange.bind(this)}
                            />
                        </div>
                        <div>
                            <label>G</label>
                            <input
                                name="g"
                                value={this.state.color.rgb.g}
                                placeholder="Green"
                                onChange={this.handleInputChange.bind(this)}
                            />
                        </div>
                        <div>
                            <label>B</label>
                            <input
                                name="b"
                                value={this.state.color.rgb.b}
                                placeholder="Blue"
                                onChange={this.handleInputChange.bind(this)}
                            />
                        </div>
                    </div>
                    <div className="color-box-group">
                        <div>
                            <label>H</label>
                            <input
                                name="h"
                                value={this.state.color.hsl.h.toFixed(0)}
                                placeholder="Hue"
                                onChange={this.handleInputChange.bind(this)}
                            />
                        </div>
                        <div>
                            <label>S</label>
                            <input
                                name="s"
                                value={
                                    (this.state.color.hsl.s * 100).toFixed(0) +
                                    "%"
                                }
                                placeholder="Saturation"
                                onChange={this.handleInputChange.bind(this)}
                            />
                        </div>
                        <div>
                            <label>L</label>
                            <input
                                name="l"
                                value={
                                    (this.state.color.hsl.l * 100).toFixed(0) +
                                    "%"
                                }
                                placeholder="Luminocity"
                                onChange={this.handleInputChange.bind(this)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let colorPalette, selectedColor;

    if (state.icons.colorPalette) {
        colorPalette = state.icons.colorPalette;
        selectedColor = state.icons.selectedColor;
    }
    return { colorPalette, selectedColor };
}

let CustomerPickerComponent = CustomPicker(ColorPicker);

let PluginColorPicker = connect(mapStateToProps, {
    setColor: actions.setColor
})(CustomerPickerComponent);

export { CustomerPickerComponent as ColorPicker, PluginColorPicker };
